import { decryptMessage } from './signalSession';
import { decryptGroupMessage } from './signalGroupCrypto';      // adaptez le chemin : fichier d'encryptGroupMessage
import { getCachedDecryption, setCachedDecryption, cacheKeyOf, signalStore } from './signalStore';

const _inflight = new Map();   

export function decryptOne(msg, currentUserId) {
  const id = cacheKeyOf(msg);                                   
  if (_inflight.has(id)) return _inflight.get(id);

  const p = (async () => {
    const cached = await getCachedDecryption(id);
    if (cached !== undefined) return cached;

    const senderId = String(msg.sender?._id || msg.senderId || msg.sender);

const recoveredAt = await signalStore.get('recoveredAt');
const sentAt = new Date(msg.createdAt).getTime();
if (recoveredAt && sentAt < recoveredAt && String(senderId) !== String(currentUserId) && msg.e2eeData.group !== true) {
  throw Object.assign(new Error('PRE_RECOVERY'), { code: 'PRE_RECOVERY' });
}
try {
    const text = msg.e2eeData.group === true
      ? await decryptGroupMessage(msg, String(currentUserId))
      : await decryptMessage(msg.e2eeData, msg.text, senderId, String(currentUserId), msg._id);

    await setCachedDecryption(id, text);
    return text;
}
catch (e) {
  console.log('[e2ee-fail]', {
    id: String(msg._id),
    group: msg.e2eeData?.group,
    textLen: msg.text?.length,
    keyForSenderLen: msg.e2eeData?.keyForSender?.length,
    members: (msg.e2eeData?.keyForMembers || []).map(m => m.userId || m.id),
    me: String(currentUserId),
    err: e.message,
  });
  throw e;
}
  })();

  _inflight.set(id, p);
  p.finally(() => _inflight.delete(id)).catch(() => {});
  return p;
}

// `messages` : uniquement les messages E2EE, en ordre CHRONOLOGIQUE (le plus ancien d'abord)
export async function decryptBatch(messages, currentUserId) {
  const cached = await Promise.all(messages.map((m) => getCachedDecryption(cacheKeyOf(m))));
  const results = new Array(messages.length);
  for (let i = 0; i < messages.length; i++) {
    if (cached[i] !== undefined) {
      results[i] = { ok: true, text: cached[i] };
      continue;
    }
    try {
      results[i] = { ok: true, text: await decryptOne(messages[i], currentUserId) };  // un à la fois
    } catch (err) {
      results[i] = { ok: false, err };
    }
  }
  return results;
}
